import React from "react";

import deleteIcon from "images/icons/invite/delete.svg";

import { useContext } from "../../Context";

export default function Actions({ row }) {
  const { dispatch, actions, state } = useContext();

  const deleteDocument = (e, row) => {
    swal(
      {
        title: "",
        text: "Do you want to delete this document?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== "A") {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.deleteDocument(dispatch, state.enterpriseId, row.id, () => {
            actions.load(dispatch, state.enterpriseId);
          });
        }
      }
    );
  };

  return (
    <div>
      <a onClick={(e) => deleteDocument(e, row)}>
        <img src={deleteIcon} />
      </a>
    </div>
  );
}
